var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"file","accept":"video/*"},on:{"change":_vm.handleChangeVideo}})
}
var staticRenderFns = []

export { render, staticRenderFns }